export const MEMBERSHIP_TYPES = {
  // Interne ID bleibt 'probewoche' (DB-Tabelle, API-Endpunkte) — Produkt heisst nach aussen 'Schnupper-Pass'
  probewoche: {
    id: 'probewoche',
    name: 'Schnupper-Pass',
    price: '49 €',
    priceType: 'Monat',
    target: 'Reinkommen, ausprobieren, kennenlernen',
    courses: '1 Monat lang alle Kurse testen, 2× pro Woche frei wählbar',
    weeklyLimit: 2,
    workshops: 'Normalpreis',
    binding: 'Keine Mindestlaufzeit · monatlich kündbar',
    highlight: '1× gratis schnuppern',
    color: '#6c757d'
  },
  entdecker: {
    id: 'entdecker',
    name: 'Entdecker-Pass',
    price: '65 €',
    priceType: 'Monat',
    target: 'Der entspannte Einstieg',
    courses: '1 Nachmittag / Woche (Mo–Fr frei wählbar, 13:30–18:00 Uhr)',
    weeklyLimit: 1,
    workshops: 'Normalpreis',
    binding: 'Mindestlaufzeit 6 Monate, danach monatlich kündbar',
    highlight: 'Der entspannte Einstieg',
    color: '#0d6efd'
  },
  digital_pilot: {
    id: 'digital_pilot',
    name: 'Digital-Pilot',
    price: '90 €',
    priceType: 'Monat',
    target: 'Unsere Empfehlung',
    courses: '2 Nachmittage / Woche (Mo–Fr frei wählbar, 13:30–18:00 Uhr)',
    weeklyLimit: 2,
    workshops: 'Vergünstigte Samstags-Workshops',
    binding: 'Mindestlaufzeit 6 Monate, danach monatlich kündbar',
    highlight: 'Unsere Empfehlung',
    recommended: true,
    color: '#198754'
  },
  astronaut: {
    id: 'astronaut',
    name: 'Astronaut-Pass',
    price: '149 €',
    priceType: 'Monat',
    target: 'Der Ganztagsschul-Ersatz',
    courses: 'Alle Nachmittage Mo–Fr (Mo–Do 13:30–18:00, Fr bis 17:00 Uhr)',
    weeklyLimit: 5,
    workshops: 'Vergünstigte Samstags-Workshops',
    binding: 'Mindestlaufzeit 6 Monate, danach monatlich kündbar',
    highlight: 'Der Ganztagsschul-Ersatz',
    color: '#6610f2'
  },
  zehnerkarte: {
    id: 'zehnerkarte',
    name: '10er-Karte',
    price: '140 €',
    priceType: 'einmalig',
    target: 'Maximale Flexibilität',
    courses: '10 Einheiten (flexibel)',
    weeklyLimit: 99, // Unbegrenzt pro Woche, aber Credits werden verbraucht
    workshops: 'Normalpreis',
    binding: 'Einmalig (10 Credits)',
    highlight: 'Nicht mehr fuer Neuantraege verfuegbar',
    color: '#fd7e14'
  },
  feriencamp: {
    id: 'feriencamp',
    name: 'Feriencamp',
    price: '180 €',
    priceType: 'einmalig',
    target: 'Feriencamp-Teilnehmer',
    courses: 'Feriencamp',
    weeklyLimit: 0,
    workshops: 'Normalpreis',
    binding: 'Einmalig',
    highlight: 'Zugang zu Feriencamp-Infos',
    color: '#9b59b6'
  }
};

// Kontingent pro Mitgliedschaftstyp (wird im Backend verwendet)
export const WEEKLY_LIMITS = {
  probewoche: 2, // Schnupper-Pass: 2x pro Woche, frei wählbare Tage
  entdecker: 1,
  digital_pilot: 2,
  astronaut: 5,
  zehnerkarte: 99,
  feriencamp: 0
};

export const getMembershipLabel = (typeId) => {
  const type = MEMBERSHIP_TYPES[typeId];
  return type ? type.name : typeId || '-';
};

export const getMembershipColor = (typeId) => {
  const type = MEMBERSHIP_TYPES[typeId];
  return type ? type.color : '#6c757d';
};

export const MEMBERSHIP_OPTIONS = Object.values(MEMBERSHIP_TYPES);
